// extracted by mini-css-extract-plugin
module.exports = {"body":"TPStep1_body__1B74J","desc":"TPStep1_desc__1lqEq","tile":"TPStep1_tile__4nIJW"};